import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import './LbxPopup.style';

export const LbxPopup = forwardRef(({ onCloseHandler, actions, children }, ref) => {
    const childrenArray = React.Children.toArray(children);
    const Footer = childrenArray[0];
    const Content = childrenArray[1];

    const Closer = () => {
        return (
            <svg block="LbxPopup" onClick={onCloseHandler} xmlns="http://www.w3.org/2000/svg" elem="close" viewBox="0 0 352 512" fill="#30302f"
                 width={24} height={24}>
                <path
                    d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93
                    89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28
                    32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48
                    0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z">
                </path>
            </svg>
        )
    }

    return (
        <div block="LbxPopup">
            <dialog ref={ref} data-dialog="lbx-popup">
                <div>
                    <div block="LbxPopup" elem="header">
                        <Closer />
                    </div>
                    <div>
                        {Content}
                    </div>
                    <div block="LbxPopup" elem="footer">
                        {Footer}
                    </div>
                </div>
            </dialog>
        </div>
    );
});

LbxPopup.propTypes = {
    onCloseHandler: PropTypes.func.isRequired,
    actions: PropTypes.node,
    children: PropTypes.node.isRequired
};
